import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { selectCurrentUserProfile } from '@libs/store';
import { statesDropdownOptions } from '@libs/site-setup';
import { DropdownSearchComponent, InputComponent } from '@libs/ui-lib';
import { Store } from '@ngrx/store';
import { EXTERNAL_LINKS } from '@libs/utils';
import { TranslateModule } from '@ngx-translate/core';
import { BaaScrollContainerComponent } from '../baa-scroll-container';
import { BaaSignModalStore } from '../baa-sign-modal.store';

@Component({
  selector: 'lib-baa-sign-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, InputComponent, DropdownSearchComponent, BaaScrollContainerComponent],
  templateUrl: './baa-sign-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaaSignFormComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly store = inject(Store);
  private readonly userProfile = this.store.selectSignal(selectCurrentUserProfile);
  protected readonly modalStore = inject(BaaSignModalStore);

  protected form!: FormGroup;
  protected readonly isSubmitted = signal(false);
  protected readonly statesDropdownOptions = statesDropdownOptions;

  protected readonly termsOfServiceUrl = EXTERNAL_LINKS.FFD_NOTES_TERMS;
  protected readonly baaUrl = EXTERNAL_LINKS.FFD_NOTES_BAA;

  public ngOnInit(): void {
    const profile = this.userProfile();
    const fullName = `${profile?.firstName ?? ''} ${profile?.lastName ?? ''}`.trim();

    this.form = this.fb.group({
      legalName: ['', Validators.required],
      address: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zip: ['', Validators.required],
      signerFullName: [{ value: fullName, disabled: true }, Validators.required],
    });
  }

  public get isDirty(): boolean {
    return this.form.dirty;
  }

  protected onSubmit(): void {
    this.isSubmitted.set(true);
    if (this.form.invalid) {
      return;
    }

    const { legalName, address, city, state, zip, signerFullName } = this.form.getRawValue();
    const signerEmail = this.userProfile()?.email ?? '';

    this.modalStore.submitBaaForm({ legalName, address, city, state, zip, signerFullName, signerEmail });
  }
}
